import { BoardingCard as BoardingCardType } from '../../../graphql/types'
import { MayBe } from '../../../types/MayBe'

export default function firstAndLastName(boardingCard: BoardingCardType): string {
  const firstName = MayBe.orElse(boardingCard.firstName || null, '')
  const lastName = MayBe.orElse(boardingCard.lastName || null, undefined)

  return `${firstName}${lastName ? ` ${lastName}` : ''}`
}
